import React, { useState } from "react";
import {
  Container,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  DonationHeader,
  Wrapper,
  Input,
  CardStyle,
  CardContentStyle,
  TypoGraphyMain,
  PageWrapper,
  TableWrapper,
  TypoGraphy,
  BarcodeImgStyle,
  DonateButton1,
  LabelWrapper,
  Input1,
  LabelWrapper1,
  Labelstyle,
  Span,
  Span1,
  Span2,
  DonateButton
} from "./style";
import {
  DonationCategory,
  Donation,
  iciciBankAccountInfo,
  maintitle,
  subtitle2,
  subtitle1,
} from "./constant";
import BarCode from "../../../assets/images/barcode.png";
import { BankInfo } from "./CopiedTableRow";
import { DonationForm } from "./DonationForm";

type PaymentProps = {
  donationCategories: DonationCategory[];
  donationPageName: string;
};

export const Payment: React.FC<PaymentProps> = ({
  donationCategories,
  donationPageName,
}) => {
  const [selectedDonations, setSelectedDonations] = useState<Donation[]>([]);
  const [customAmount, setCustomAmount] = useState<number>(0);
  const [isDonationFormVisible, setIsDonationFormVisible] = useState(false);

  const handleDonationSelect = (donation: Donation) => {
    const existingDonation = selectedDonations.find((d) => d.id === donation.id);
  
    if (existingDonation) {
      setSelectedDonations((prevState) =>
        prevState.filter((d) => d.id !== donation.id)
      );
    } else {
      // amount can be null here, that's okay
      setSelectedDonations((prevState) => [...prevState, donation]);
    }
  };
  

  const totalDonationAmount = selectedDonations.reduce(
    (acc, curr) => acc + (curr.amount ?? 0),
    customAmount,
  );

  const handleCloseForm = () => {
    setIsDonationFormVisible(false);
  };

  const handleSubmitDonationForm = (formData: any) => {};

  const formatAmountInINR = (amount: number | bigint) => {
    const formattedAmount = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(amount);

    return formattedAmount.replace(/\.00$/, "");
  };

  const handleDonateButtonClick = () => {
    setIsDonationFormVisible(true);
    if (totalDonationAmount < 19) {
      alert("Please note that the minimum donation amount is 20₹");
      setIsDonationFormVisible(false);
    } else {
      setIsDonationFormVisible(true);
    }
  };

  // Check if any donation has valid amount
  const hasValidAmounts = donationCategories.some((cat) =>
    cat.donations.some((d) => d.amount !== null)
  );

  const hasAnyDonations = donationCategories.some(
    (cat) => cat.donations.length > 0
  );

  return (
    <>
      <Wrapper>
        <Container>
          <form>
            {hasAnyDonations && (
              <>
                {hasValidAmounts ? (
                  /* ---------- TABLE ---------- */
                  <Table>
                    <thead>
                      <tr>
                        <TableHeader>Select</TableHeader>
                        <TableHeader>Donation</TableHeader>
                        <TableHeader>Amount</TableHeader>
                      </tr>
                    </thead>
                    <tbody>
                      {donationCategories.map((category) =>
                        category.donations.length > 0 ? (
                          <React.Fragment key={category.title}>
                            <TableCell colSpan={3}>
                              <DonationHeader>{category.title}</DonationHeader>
                            </TableCell>

                            {category.donations.map((donation) => (
                              <TableRow key={donation.id}>
                                <TableCell>
                                  <Input
                                    type="checkbox"
                                    checked={!!selectedDonations.find(
                                      (d) => d.id === donation.id
                                    )}
                                    onChange={() => handleDonationSelect(donation)}
                                  />
                                </TableCell>
                                <TableCell>{donation.title}</TableCell>
                                <TableCell>
                                  {donation.amount !== null
                                    ? formatAmountInINR(donation.amount)
                                    : "0"}
                                </TableCell>
                              </TableRow>
                            ))}
                          </React.Fragment>
                        ) : null
                      )}
                    </tbody>
                  </Table>
                ) : (
                  /* ---------- MANUAL INPUT ---------- */
                  donationCategories.map((category) =>
                    category.donations.length > 0 ? (
                      <div key={category.title} style={{ marginBottom: "1.5rem" }}>
                        <DonationHeader>{category.title}</DonationHeader>

                        {category.donations.map((donation) => (
                          <div
                            key={donation.id}
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 60%",
                              alignItems: "center",
                            }}
                          >
                            <TableCell>{donation.title}</TableCell>

                            <Input1
                              type="number"
                              placeholder="Enter amount"
                              value={
                                selectedDonations.find((d) => d.id === donation.id)
                                  ?.amount || ""
                              }
                              onChange={(e) =>
                                setSelectedDonations((prev) => [
                                  ...prev.filter((d) => d.id !== donation.id),
                                  {
                                    ...donation,
                                    amount: Number(e.target.value),
                                  },
                                ])
                              }
                            />
                          </div>
                        ))}
                      </div>
                    ) : null
                  )
                )}

                <LabelWrapper1>
                  <Labelstyle>
                    Total Amount:- {formatAmountInINR(totalDonationAmount)}
                  </Labelstyle>

                  <DonateButton
                    className="App-button"
                    onClick={handleDonateButtonClick}
                    type="button"
                  >
                    Donate
                  </DonateButton>
                </LabelWrapper1>
              </>
            )}

            <br />
            <Span2>
              {donationCategories.some(cat => cat.donations.length > 0)
                ? "Or, Donation of your choice:-"
                : "Donation of your choice:-"}
            </Span2>
            <LabelWrapper>
              <Input1
                type="number"
                placeholder="Enter amount"
                onChange={(e) => setCustomAmount(Number(e.target.value))}
              />
              <DonateButton1
                className="App-button"
                onClick={handleDonateButtonClick}
                type="button"
              >
                Donate
              </DonateButton1>
            </LabelWrapper>
          </form>
        </Container>
      </Wrapper>

      {isDonationFormVisible && (
        <DonationForm
          onClose={handleCloseForm}
          onSubmit={handleSubmitDonationForm}
          totalDonationAmount={totalDonationAmount}
          selectedDonations={selectedDonations}
          donationPageName={donationPageName}
        />
      )}

      <br />
      <br />
      <Span>Gupt Daan (Anonymous Donation)</Span>
      <br />
      <Span1>You can contribute anonymously via <strong>NEFT / RTGS / UPI</strong>.</Span1>
      <br />
      <Span1><strong>Please note:</strong> This option is available only for Indian citizens or Indian passport holders.</Span1>
      <br />
      <Span1>Since this is an anonymous donation, we will not have your details and therefore <strong>cannot provide a receipt</strong>. If you require a receipt, please use above payment method.</Span1>
      <br />
      <Span1>Thank you for your generous support!</Span1>


      <PageWrapper>
        <CardStyle>
          <CardContentStyle>
            <TypoGraphyMain>Donate via NEFT/RTGS</TypoGraphyMain>
            <TableWrapper>
              <BankInfo accountInfo={iciciBankAccountInfo} />
            </TableWrapper>
          </CardContentStyle>
        </CardStyle>
        <CardStyle>
          <CardContentStyle>
            <TypoGraphyMain>{maintitle}</TypoGraphyMain>
            <TypoGraphy>{subtitle1}</TypoGraphy>
            <TypoGraphy>{subtitle2}</TypoGraphy>
            <BarcodeImgStyle image={BarCode} />
          </CardContentStyle>
        </CardStyle>
      </PageWrapper>
    </>
  );
};
